let isReloading = false

if (import.meta.hot) {
	import.meta.hot.on("vite:beforeFullReload", () => {
		isReloading = true
	})
}

export const isViteReloading = () => isReloading
